import styled from 'styled-components';
import { COLOR } from '../../../assets/constants/constants';

const { primary } = COLOR;

const StyledTitleWithSub = styled.div`
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  text-transform: uppercase;
`;

const StyledBorder = styled.div`
  margin-bottom: 34px;
  border-bottom: none;
  border-top: 1px solid ${primary};
  &.bottom-border {
    margin-top: 14px;
  }
`;

const StyledTitle = styled.div`
  display: flex;
  justify-content: space-between;
  text-transform: uppercase;
  color: #1A1919;
  font-family: Serif;
  letter-spacing: 0.96px;
  font-size: 22px;
  cursor: pointer;
  
  :hover {
    color: #AEDBD9;
  }

  &.first-title {
    margin-bottom: 16px;
  }

  &.title-with-sub {
    margin-bottom: 23px;
  }
`;

const StyledDiv = styled.div`
  max-width: 461px;
  height: 100vh;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 13% 70% 15%;

  @media (min-width: 768px) {
    grid-template-rows: 13% 68% 19%;
  }

  @media (max-width: 600px) {
    width: 100vw;
  }
`;

const StyledIcon = styled.div`
  padding-left: 15px;
  padding-top: 5px;
  cursor: pointer;
  svg {
    path {
      stroke-width: 0.78;
    }
  }
  @media (max-width: 600px) {
    padding-top: 10px;
  }
`;

const StyledMenuHeader = styled.div`
  grid-column: 1;
  grid-row: 1;
  display: flex;
  justify-content: space-between;
  padding: 40px;

  @media (max-width: 600px) {
    padding: 0;
  }
`;

const StyledSharedIcons = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 25px 10px;
  width: auto;

  a {
    margin: 0 8px;
  }
  
  @media (min-width: 768px){
    width: 145px;

    a {
      margin: 0 4px;
    }
  }

  cursor: pointer;
  svg {
    fill: #BBC3C3;
    height: 1.3em;
    width: 1.3em;
    :hover {
      fill: #AEDBD9;
    }
  }
`;

const StyledMenuMain = styled.div`
  grid-column: 1;
  grid-row: 2;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px 20px 0 20px;
  overflow: auto;

  @media (min-width: 768px) {
    padding: 1.8em 3.8em 0;
  }
`;

const StyledMenuFooter = styled.div`
  // laptop
  @media (min-width: 768px) and (max-height: 700px){
    overflow: hidden;
  }
`;

export {
  StyledDiv,
  StyledIcon,
  StyledTitle, 
  StyledBorder,
  StyledMenuMain,
  StyledMenuHeader,
  StyledMenuFooter,
  StyledSharedIcons,
  StyledTitleWithSub,
}
